// extracted by mini-css-extract-plugin
export var copy = "fc-copy-block-module--copy--9d617";
export var grid = "fc-copy-block-module--grid--db2e7";
export var root = "fc-copy-block-module--root--d8248";
export var title = "fc-copy-block-module--title--109de";
export var wrap = "fc-copy-block-module--wrap--e05bf";